export default "__VITE_ASSET__DCA5SCK$__"